(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-ecome-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-testid^="home-ecome-testimonials-"]');
    if (!roots.length) return;

    roots.forEach((root) => {
      if (root.dataset.carouselInit === 'true') return;
      root.dataset.carouselInit = 'true';

      const carousel = root.querySelector('[data-testimonials-carousel]');
      const track = root.querySelector('[data-testimonials-track]');
      if (!carousel || !track) return;

      const autoplayEnabled = root.dataset.autoplay === 'true';
      if (!autoplayEnabled) return;

      const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reducedMotionQuery.matches) return;

      const sourceCards = Array.from(track.querySelectorAll('.anubis-testimonials__card'));
      if (sourceCards.length < 2) return;

      const cloneFragment = document.createDocumentFragment();
      sourceCards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea').forEach((focusable) => {
          focusable.setAttribute('tabindex', '-1');
        });
        cloneFragment.appendChild(clone);
      });
      track.appendChild(cloneFragment);

      const secondsPerCard = Math.max(4, Number.parseFloat(root.dataset.autoplaySpeed || '8') || 8);
      let inView = true;

      const configureAnimation = () => {
        const style = window.getComputedStyle(track);
        const gap = Number.parseFloat(style.columnGap || style.gap || '0') || 0;
        const originals = sourceCards;
        if (!originals.length) return;

        let loopDistance = 0;
        originals.forEach((card, index) => {
          loopDistance += card.getBoundingClientRect().width;
          if (index < originals.length - 1) loopDistance += gap;
        });
        if (loopDistance <= 0) return;

        const firstCardWidth = originals[0].getBoundingClientRect().width || 260;
        const pxPerSecond = Math.max(8, (firstCardWidth + gap) / secondsPerCard);
        const duration = Math.max(18, loopDistance / pxPerSecond);

        carousel.style.setProperty('--anubis-testimonials-distance', `${Math.round(loopDistance)}px`);
        carousel.style.setProperty('--anubis-testimonials-duration', `${duration.toFixed(2)}s`);
      };

      const resume = () => {
        if (reducedMotionQuery.matches || document.hidden || !inView) return;
        carousel.classList.remove('is-paused');
      };

      const pause = () => {
        carousel.classList.add('is-paused');
      };

      configureAnimation();
      carousel.classList.add('is-ready');

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            inView = Boolean(entry && entry.isIntersecting && entry.intersectionRatio > 0.1);
            if (inView) resume();
            else pause();
          },
          { threshold: [0, 0.1, 0.25], rootMargin: '120px 0px 120px 0px' }
        );
        observer.observe(root);
      }

      if (typeof reducedMotionQuery.addEventListener === 'function') {
        reducedMotionQuery.addEventListener('change', () => {
          if (reducedMotionQuery.matches) pause();
          else resume();
        });
      }

      carousel.addEventListener('mouseenter', pause);
      carousel.addEventListener('mouseleave', resume);
      carousel.addEventListener('focusin', pause);
      carousel.addEventListener('focusout', resume);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) pause();
        else resume();
      });

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(() => {
          configureAnimation();
        });
        ro.observe(track);
        sourceCards.forEach((card) => ro.observe(card));
      } else {
        window.addEventListener('resize', configureAnimation);
      }

      track.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', configureAnimation, { once: true });
        }
      });

      resume();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["platform-product-mosaic"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('platform-product-mosaic')) {
    customElements.define('platform-product-mosaic', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-mosaic-track]');
        this.prev = this.querySelector('[data-mosaic-prev]');
        this.next = this.querySelector('[data-mosaic-next]');
        this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -this.track.clientWidth * 0.88, behavior: 'smooth' }));
        this.next?.addEventListener('click', () => this.track.scrollBy({ left: this.track.clientWidth * 0.88, behavior: 'smooth' }));
        this.track?.addEventListener('scroll', () => this.updateControls(), { passive: true });
        window.addEventListener('resize', () => this.updateControls());
        this.loadProducts();
        requestAnimationFrame(() => this.updateControls());
      }

      updateControls() {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 2 || max <= 2;
      }

      async loadProducts() {
        const queryValue = this.dataset.query;
        if (!queryValue || !this.track) return;
        const limit = Math.min(Math.max(Number.parseInt(this.dataset.limit || '6', 10), 4), 10);
        const query = new URLSearchParams({ q: queryValue, 'resources[type]': 'product', 'resources[limit]': String(limit) });
        try {
          const response = await fetch(`/search/suggest.json?${query.toString()}`, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const data = await response.json();
          const products = data?.resources?.results?.products;
          if (!Array.isArray(products) || !products.length) return;
          // Mismo formato que Liquid: se toma shop.money_format de la tienda.
          // Va en data-money-format: en este bloque javascript Shopify no
          // procesa Liquid, y escrito aqui dejaba un error de sintaxis.
          const formatoTienda = (window.AnubisShop && window.AnubisShop.moneyFormat) || this.dataset.moneyFormat;
          const money = {
            format(importe) {
              const f = formatoTienda;
              if (!f) return String(importe);
              const token = (f.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || 'amount';
              let miles = ',', dec = '.';
              if (token.indexOf('comma_separator') !== -1) { miles = '.'; dec = ','; }
              else if (token.indexOf('apostrophe_separator') !== -1) { miles = "'"; }
              else if (token.indexOf('space_separator') !== -1) { miles = ' '; dec = ','; }
              const n = Number(importe) || 0;
              const t = token.indexOf('no_decimals') !== -1 ? String(Math.round(n)) : n.toFixed(2);
              const p = t.split('.');
              const ent = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
              return f.replace(/\{\{\s*\w+\s*\}\}/, p[1] ? ent + dec + p[1] : ent);
            }
          };
          const fragment = document.createDocumentFragment();
          products.slice(0, limit).forEach((product) => {
            const price = Number.parseInt(product.price_min || product.price || '0', 10);
            const compare = Number.parseInt(product.compare_at_price_min || '0', 10);
            const imageUrl = product.image || product.featured_image?.url;
            const article = document.createElement('article');
            article.className = 'platform-mosaic__product';
            const link = document.createElement('a');
            link.href = product.url;
            link.setAttribute('aria-label', product.title);
            const thumb = document.createElement('span');
            thumb.className = 'platform-mosaic__thumb';
            if (imageUrl) {
              const image = document.createElement('img');
              image.src = imageUrl;
              image.alt = product.title;
              image.loading = 'lazy';
              thumb.append(image);
            }
            const copy = document.createElement('span');
            copy.className = 'platform-mosaic__product-copy';
            const title = document.createElement('strong');
            title.textContent = product.title;
            const priceLine = document.createElement('span');
            priceLine.className = 'platform-mosaic__price';
            if (compare > price) {
              const oldPrice = document.createElement('del');
              oldPrice.textContent = money.format(compare);
              priceLine.append(oldPrice);
            }
            const currentPrice = document.createElement('b');
            currentPrice.textContent = money.format(price);
            priceLine.append(currentPrice);
            copy.append(title, priceLine);
            link.append(thumb, copy);
            article.append(link);
            fragment.append(article);
          });
          this.track.replaceChildren(fragment);
          requestAnimationFrame(() => this.updateControls());
        } catch (error) {
          this.dataset.loadState = 'failed';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
